import { render, staticRenderFns } from "./CustomerPaPlanSelect.vue?vue&type=template&id=08387ef2"
import script from "./CustomerPaPlanSelect.vue?vue&type=script&lang=js"
export * from "./CustomerPaPlanSelect.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/customer-pa.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports